const PhoneIcon = ({width=18, height=18, color="#64647A"}) => {
  return (
    <svg width={width} height={height} viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.82197 1H3.28571C2.02335 1 1 2.02335 1 3.28571V5.57143C1 11.8833 6.11675 17 12.4286 17H14.7143C15.9767 17 17 15.9767 17 14.7143V13.1349C17 12.702 16.7554 12.3063 16.3682 12.1127L13.6072 10.7322C12.9851 10.4211 12.2318 10.7332 12.0119 11.393L11.6716 12.4139C11.4511 13.0752 10.7728 13.4688 10.0892 13.3321C7.35347 12.785 5.21502 10.6465 4.66787 7.91076C4.53116 7.22723 4.92483 6.54887 5.58612 6.32843L6.85313 5.9061C7.41967 5.71725 7.7453 5.12406 7.60046 4.54471L6.9307 1.86567C6.80351 1.35691 6.34639 1 5.82197 1Z"
        stroke={color}
      />
    </svg>
  );
};

export default PhoneIcon;
